import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import AsyncSelect from 'react-select/async';
import { flowsApi } from '../../../api/flows';
import { debounce } from '../../../utils/debounce';
import { placeholderStyle } from '../../AddSegment/Condition/Condition.constants';
import {
  MultiValueLabel,
  MultiValueRemove,
} from '../../AddSegment/components/labels';
import styles from '../Contacts.module.scss';

const Flows = ({ flows, setFlows, isLoading }) => {
  const dispatch = useDispatch();

  const loadOptions = useCallback(
    async (inputValue) => {
      try {
        const apiResult = await dispatch(
          flowsApi.endpoints.getFlowOptions.initiate(
            {
              search: inputValue,
            },
            {
              forceRefetch: true,
            }
          )
        ).unwrap();

        const flowData =
          apiResult?.results?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || [];

        const sorted = flowData.sort((a, b) => a.label.localeCompare(b.label));
        return sorted;
      } catch (error) {
        return [];
      }
    },
    [dispatch]
  );

  const debouncedLoadOptions = useMemo(
    () => debounce(loadOptions, 1000),
    [loadOptions]
  );

  return (
    <div className={styles.filter_row}>
      <span className={styles.label}>Flows</span>

      <AsyncSelect
        styles={placeholderStyle}
        maxMenuHeight={194}
        components={{
          // eslint-disable-next-line react/no-unstable-nested-components
          MultiValueRemove: (props) => (
            <MultiValueRemove props={props} show="label" />
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          MultiValueLabel: (props) => (
            <MultiValueLabel props={props} show="label" />
          ),
        }}
        className="w-100"
        value={flows}
        loadOptions={debouncedLoadOptions}
        isSearchable
        onChange={(newValue) => {
          setFlows(newValue);
        }}
        isLoading={isLoading}
        defaultOptions
        cacheOptions
        isShowValue
        isMulti
      />
    </div>
  );
};

export default Flows;
